import { TravelPurposeState } from "@flights/types";

export type State = TravelPurposeState;

export const getInitialState = (): TravelPurposeState => ({
  travelPurpose: "leisure"
});
